import { useContext, useEffect, useRef, useState } from 'react';
import AuthContext from '../../store/auth-context';
import { getWhatsNewStatus, markWhatsNewSeen } from '../../api/whats-new-api';
import {
	CURRENT_APP_VERSION,
	roleToWhatsNewAudience,
	unreadWhatsNewEntries,
	type WhatsNewEntry,
} from '../../whats-new';
import WhatsNewDialog from './WhatsNewDialog';
import { debugError } from '../../utils/debug';

/**
 * Po zalogowaniu do panelu pokazuje dialog z niewidzianymi wpisami.
 * Nowo zarejestrowani mają już ustawione lastSeen przy tworzeniu konta (BE) —
 * więc nie dostają okna na wstępie.
 */
const WhatsNewHost = () => {
	const { token, role } = useContext(AuthContext);
	const [entries, setEntries] = useState<WhatsNewEntry[]>([]);
	const [open, setOpen] = useState(false);
	const ranForUser = useRef<string | null>(null);

	useEffect(() => {
		const audienceRole = roleToWhatsNewAudience(role);
		if (!token || !audienceRole || audienceRole === 'student') {
			return;
		}
		const runKey = `${token}:${audienceRole}`;
		if (ranForUser.current === runKey) {
			return;
		}
		ranForUser.current = runKey;

		let cancelled = false;
		(async () => {
			try {
				const status = await getWhatsNewStatus(token);
				if (cancelled) return;

				const unread = unreadWhatsNewEntries({
					role: audienceRole,
					currentVersion: CURRENT_APP_VERSION,
					lastSeenVersion: status.lastSeenAppVersion,
				});
				if (unread.length > 0) {
					setEntries(unread);
					setOpen(true);
				}
			} catch (e) {
				debugError('WhatsNewHost:', e);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [token, role]);

	const onDismiss = async () => {
		if (token) {
			try {
				await markWhatsNewSeen(token, CURRENT_APP_VERSION);
			} catch (e) {
				debugError('WhatsNewHost mark seen:', e);
			}
		}
		setOpen(false);
		setEntries([]);
	};

	return (
		<WhatsNewDialog
			entries={entries}
			open={open}
			onDismiss={onDismiss}
		/>
	);
};

export default WhatsNewHost;
